import CheckBoxIcon from '@mui/icons-material/CheckBox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import React from 'react';

function ApplySelectionButton({ onClick }: { onClick: () => void }) {
  return (
    <Tooltip title="Apply selected items">
      <IconButton onClick={onClick} aria-label="row">
        <CheckBoxIcon />
      </IconButton>
    </Tooltip>
  );
}

export default ApplySelectionButton;
